'use client';

import React, { type ComponentProps, type FC } from 'react';
import { CartItem as BaseCartItem } from '@kidslabs/module-quote';
import { CartItemAdditionalInformation } from '../cart-item-additional-information';

/**
 * CartItem - Cart item wrapper for Nova theme
 *
 * Injects CartItemAdditionalInformation component to show:
 * - Stock availability status
 * - Flash sale status
 *
 * Uses CartItem from module-quote which handles:
 * - Stock availability logic (auto-disable out-of-stock items)
 * - Out of stock messages
 * And passes CartItemAdditionalInfoComponent down to CartItemV2 from UI Core.
 *
 * Matches mobile module-theme-hermes implementation:
 * @see mobile-ecommerce/applications/module-theme-hermes/src/modules/quote/components/cart-item/cart-item.tsx
 */
export const CartItem: FC<ComponentProps<typeof BaseCartItem>> = props => {
    return <BaseCartItem {...props} CartItemAdditionalInfoComponent={CartItemAdditionalInformation} />;
};

export default CartItem;
